import { render, staticRenderFns } from "./GalleryFilters.vue?vue&type=template&id=59274e0a&scoped=true&"
import script from "./GalleryFilters.vue?vue&type=script&lang=ts&"
export * from "./GalleryFilters.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryFilters.vue?vue&type=style&index=0&id=59274e0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59274e0a",
  null
  
)

export default component.exports